import { HttpBackend, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { CamPermissionsService } from '@camelot/user';

import { environment } from 'src/environments/environment';

import { VisitorTokenService } from './visitor-token.service';

@Injectable()
export class VisitorInterceptor implements HttpInterceptor {
  private readonly _backend = inject(HttpBackend);
  private readonly _permissionsService = inject(CamPermissionsService);
  private readonly _visitorTokenService = inject(VisitorTokenService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.STRAPI_SERVER_CONFIG.url && req.url.startsWith(environment.STRAPI_SERVER_CONFIG.url)) {
      return next.handle(req);
    }

    const session = this._visitorTokenService.session();
    if (!session || this._permissionsService.isAuthenticated || !req.url.startsWith(environment.AADB2C.apiConfig.uri)) {
      return next.handle(req);
    }

    return this._backend.handle(
      session.token ? req.clone({ headers: req.headers.set('Authorization', `Visitor ${session.token}`) }) : req
    );
  }
}
